import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from 'react-query';
import styled from 'styled-components';
import { Task, TaskAPI } from 'api/tasks';
import { Button } from 'components/atoms/button';
import {
  CpBody00Primary,
  CpBody00Secondary,
} from 'components/atoms/customer-portal/typography';
import { useCsatQuery } from 'queries';
import { getTaskDetailQueryKey } from 'queries/task';
import { CpCsatModal } from './cp-add-csat-modal';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  height: calc(100% - 53px - 46px);
  overflow-y: auto;
  padding-bottom: var(--cp-spacing-07);
  flex-direction: column;
`;

const CsatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--cp-spacing-05);
  border-bottom: 1px solid var(--cp-gray-10);
  cursor: pointer;
  width: 100%;
  &:hover {
    background-color: var(--cp-gray-10);
  }
`;

const CsatAvatarAndTaskNameWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: var(--cp-spacing-03);
`;

// const CsatAvatarWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-left: var(--cp-spacing-03);
// `;

const CsatTaskName = styled(CpBody00Primary)``;

const CsatBreadCrumbsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: var(--cp-spacing-03);
`;

const CsatBreadCrumbs = styled(CpBody00Secondary)``;

const CsatRateExperienceButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: var(--cp-spacing-06);

  ${Button} {
    padding-left: 0;
  }
`;

const CpCsat: React.FC<{
  csat: Task;
  onClick: VoidFunction;
}> = ({ csat, onClick }) => {
  return (
    <CsatWrapper>
      <CsatAvatarAndTaskNameWrapper>
        <CsatTaskName>
          <FormattedMessage
            id="milestone_completed"
            values={{
              taskName: csat?.taskName,
            }}
          />
        </CsatTaskName>
      </CsatAvatarAndTaskNameWrapper>
      <CsatBreadCrumbsWrapper>
        <CsatBreadCrumbs>
          {[
            csat?.project?.projectId,
            csat?.parentTaskObject?.taskName,
            csat?.taskName,
          ]
            .filter(Boolean)
            .join(' > ')}
        </CsatBreadCrumbs>
      </CsatBreadCrumbsWrapper>
      <CsatRateExperienceButtonWrapper>
        <Button onClick={onClick} type="link">
          <FormattedMessage id="rate_your_experience" />
        </Button>
      </CsatRateExperienceButtonWrapper>
    </CsatWrapper>
  );
};

export const CpCsatTab: React.FC = () => {
  const { data: csatData } = useCsatQuery();
  const [selectedCsat, setSelectedCsat] = React.useState<Task | null>(null);
  const queryClient = useQueryClient();

  return (
    <>
      <Wrapper>
        {csatData?.map((csat) => (
          <CpCsat
            key={csat.taskId}
            csat={csat}
            onClick={() => {
              setSelectedCsat(csat);
            }}
          />
        ))}
      </Wrapper>
      <CpCsatModal
        csat={selectedCsat}
        visible={!!selectedCsat}
        onCancel={() => setSelectedCsat(null)}
        onSubmit={({ message, rating }) => {
          if (selectedCsat) {
            TaskAPI.addRating(selectedCsat?.taskId, {
              rating,
              comment: message,
            }).then(() => {
              queryClient.refetchQueries('CSAT');
              queryClient.refetchQueries(
                getTaskDetailQueryKey([
                  'task_id',
                  selectedCsat?.project?.projectId,
                  selectedCsat?.taskId,
                ]),
              );
            });
          }
          queueMicrotask(() => {
            setSelectedCsat(null);
          });
        }}
      />
    </>
  );
};
